import {
  buildCompletedPaperParts,
  getSessionModeLabel,
} from "./completedPaperReviewUtils";
import {
  formatQuestionBody,
} from "./questionHtmlFormatter";
import "./CompletedPaperReview.css";
import "./Tutor.css";

function CompletedPaperReview({
  language,
  paperReview,
  onBack,
}) {
  const result = paperReview.result;

  return (
    <main className="completed-paper-review">
      <div className="completed-paper-review-header">
        <div>
          <p className="completed-paper-review-eyebrow">
            {language === "af"
              ? "Voltooide vraestel"
              : "Completed paper"}
          </p>
          <h1>{result.paper_title}</h1>
          <div className="completed-paper-review-meta">
            <span>
              {getSessionModeLabel(
                result.selection_type,
                language
              )}
            </span>
            <span>
              {new Date(
                result.completed_at
              ).toLocaleDateString(
                language === "af"
                  ? "af-ZA"
                  : "en-ZA",
                {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                }
              )}
            </span>
          </div>
        </div>

        <div className="completed-paper-review-score">
          <strong>
            {Math.round(Number(result.percentage))}%
          </strong>
          <span>
            {Number(result.total_marks_awarded)}/
            {Number(result.total_marks_available)}
          </span>
        </div>
      </div>

      <button
        type="button"
        className="completed-paper-back"
        onClick={onBack}
      >
        ← {language === "af"
          ? "Terug na vorige vraestelle"
          : "Back to previous papers"}
      </button>

      <section className="completed-paper-questions">
        {paperReview.questions.flatMap(
          (question) =>
            buildCompletedPaperParts(question)
              .map((part) => (
                <article
                  className="completed-paper-question"
                  key={`${question.question_id}-${part.number}`}
                >
                  <div className="completed-paper-question-heading">
                    <h2>
                      {language === "af"
                        ? "Vraag"
                        : "Question"}{" "}
                      {part.number}
                    </h2>
                    <span>
                      {part.marks}{" "}
                      {language === "af"
                        ? "punte"
                        : "marks"}
                    </span>
                  </div>

                  <div
                    className="completed-paper-question-text tutor-message-html"
                    dangerouslySetInnerHTML={{
                      __html: formatQuestionBody(
                        part.questionText
                      ),
                    }}
                  />

                  {part.answers.length > 0 ? (
                    <div className="completed-paper-attempts">
                      {part.answers.map((answer) => (
                        <div
                          className="completed-paper-attempt"
                          key={answer.answer_id}
                        >
                          <div className="completed-paper-attempt-heading">
                            <strong>
                              {language === "af"
                                ? "Leerderpoging"
                                : "Learner attempt"}{" "}
                              {answer.attempt_number}
                            </strong>
                            <span>
                              {Number(
                                answer.marks_awarded || 0
                              )}/{part.marks}
                            </span>
                          </div>

                          <div className="completed-paper-learner-answer">
                            {answer.answer_text}
                          </div>

                          {answer.tutor_feedback && (
                            <div
                              className="completed-paper-feedback tutor-message-html"
                              dangerouslySetInnerHTML={{
                                __html: formatQuestionBody(
                                  answer.tutor_feedback
                                ),
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="completed-paper-no-answer">
                      {language === "af"
                        ? "Geen gestoorde antwoord nie."
                        : "No saved answer."}
                    </p>
                  )}
                </article>
              ))
        )}
      </section>
    </main>
  );
}

export default CompletedPaperReview;
